var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showFooter)?_c('div',{staticClass:"footer-main"},[_c('footer',{staticClass:"footer"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"footer_row"},[_c('div',{staticClass:"footer_text"},[_vm._v("@ "+_vm._s(_vm.year())+" MiXX Play")])])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }